import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { IBoardEmailSectionProps } from './types';
import { BoardEmailHOC } from '../../hocs/BoardEmailHOC/BoardEmailHOC';
import { BOARD_SECTION_EMAIL } from '../../constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function BoardEmailSection ({
}: IBoardEmailSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--email';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.BOARD_EMAIL} />
            <SettingsSection
                className={className}
                title={BOARD_SECTION_EMAIL}
            >
                <BoardEmailHOC boardId={boardId} />
            </SettingsSection>
        </>
    );
};
